import { AppApiGateway } from '@repo/api/web/AppApiGateway'
import type {
  AttributeDto,
  AttributesListDto,
  ChannelCategoriesDto,
} from '@repo/api/web/models'
import { injectable, inject } from 'inversify'

import type { CategoryDto } from '#Products/models/Pim/CategoryDto'

@injectable()
export class PimService {
  protected appConfig: ReturnType<typeof useAppConfig>

  constructor(@inject(AppApiGateway) readonly api: AppApiGateway) {
    this.appConfig = useAppConfig()
  }

  categoriesList() {
    return this.api.categoriesList(this.appConfig.host) as Promise<
      ChannelCategoriesDto & { allByIds: CategoryDto[] }
    >
  }

  categoriesListAttributes(categoryId: number) {
    return this.api.categoriesListAttributes(categoryId, this.appConfig.host)
  }

  attributesList() {
    return this.api.attributesList(this.appConfig.host) as Promise<
      AttributesListDto & { allByIds: Record<string, AttributeDto> }
    >
  }
}
